import * as Yup from 'yup'

const validationSchema = () =>
	Yup.object().shape({
		//seedPhrase: Yup.string().required().min(30).max(128)
		token: Yup.string().required()
	})

export default validationSchema
